<div class="sales-approval-container">
  <h2>Sales Approval</h2>

  <div class="toolbar">
    <button (click)="loadData()">🔄 Refresh</button>
     <button (click)="approveSelected()">✅ Approve</button>
    <button (click)="rejectSelected()">❌ Reject</button>
  </div>

  <table class="styled-table" border="1">
  <thead>
    <tr>
      <th>Select</th>
      <th>#</th>
      <th>Barcode</th>
      <th>Store Name</th>
      <!-- <th>Tax</th>
      <th>Total</th> -->
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let sale of salesList; let i = index">
      <td><input type="radio" name="selected" (change)="selectRow(sale)" /></td>
      <td>{{ i + 1 }}</td>
      <td>{{ sale.Barcode }}</td>
      <td>{{ sale.StoreName }}</td>
      <!-- <td>{{ sale.Tax }}</td>
      <td>{{ sale.Total }}</td> -->
    </tr>
    <tr *ngIf="salesList.length === 0">
      <td colspan="6" style="text-align:center;">No sales data available</td>
    </tr>
  </tbody>
</table>

</div>
